import { api } from "../../http";

async function GetAllCount() {
    try {
        // /count-status/:status
        const { data: revisao } = await api.get(`/rrim/list/count-status/1`);
        const { data: aprovados } = await api.get(`/rrim/list/count-status/2`);
        const { data: reprovados } = await api.get(`/rrim/list/count-status/3`);

        return { revisao: revisao.count, aprovados: aprovados.count, reprovados: reprovados.count}
        
    } catch (error) {
        console.log(error)
    }
}

export { GetAllCount }